import { render, staticRenderFns } from "./ProductContentExams.vue?vue&type=template&id=0943f311&scoped=true"
import script from "./ProductContentExams.vue?vue&type=script&lang=js"
export * from "./ProductContentExams.vue?vue&type=script&lang=js"
import style0 from "./ProductContentExams.vue?vue&type=style&index=0&id=0943f311&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0943f311",
  null
  
)

export default component.exports